import React, { useState } from 'react'
import "./Join.css"
import logo from "../images/favicon.png"
import { Link } from 'react-router-dom'

let user;
const sendUser = () => {
    user = document.getElementById('joinInput').value;
    document.getElementById('joinInput').value = '';
}
const Join = () => {

    const [name, setName] = useState('')

    return (
        <div className='JoinPage'>
            <div className="joinContainer">
                <img src={logo} alt="logo" />
                <h1>C-CHAT</h1>
                <input onChange={(e) => setName(e.target.value)} type="text" placeholder='Enter Your Name' id='joinInput' />
                <Link onClick={(event) => !name ? event.preventDefault() : null} to="/chat"><button onClick={sendUser}>Log In</button></Link>
            </div>
        </div>
    )
}

export default Join
export { user }
